import { Button, Form, Modal, message } from "antd";
import { useState } from "react";
import DataTable from "../../../../../components/Tables/DataTable";
import FormModal from "./FormModal";
import {
  useAddTaxMutation,
  useDeleteTaxMutation,
  useEditTaxMutation,
  useGetTaxesQuery,
} from "../../../../../redux/Service/TaxesApi";

function Taxes() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const { data: taxesData, isLoading: isTaxesLoading } =
    useGetTaxesQuery(undefined);
  const taxes = taxesData?.ResponseObject ?? [];

  const [deleteTax, { isLoading: isDeleting }] = useDeleteTaxMutation();
  const [addTax, { isLoading: isAdding }] = useAddTaxMutation();
  const [updateTax, { isLoading: isUpdating }] = useEditTaxMutation();

  const handleDeleteClick = (record) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف الضريبة "${record.TaxName}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteTax(record.TaxID).unwrap();
          if (response?.ResponseObject === true) {
            message.success("تم حذف الضريبة بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const columns = [
    { title: "اسم الضريبة", dataIndex: "TaxName", key: "TaxName" },
    { title: "نسبة الضريبة", dataIndex: "TaxRate", key: "TaxRate" },
  ];

  const handleOk = async (values) => {
    try {
      const response = isEditing
        ? await updateTax(values).unwrap()
        : await addTax(values).unwrap();

      if (response?.ResponseObject === true) {
        message.success(
          isEditing ? "تم تعديل الضريبة بنجاح" : "تمت إضافة الضريبة بنجاح"
        );
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch {
      message.error("فشل الاتصال بالخادم");
    }
  };

  const resetModal = () => {
    form.resetFields();
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleEditClick = (record) => {
    setIsEditing(true);
    setIsModalOpen(true);
    form.setFieldsValue(record);
  };

  return (
    <div className="flex flex-wrap gap-4 relative">
      <div className="grid justify-start my-2">
        <Button
          type="primary"
          style={{ width: "10rem" }}
          onClick={() => setIsModalOpen(true)}
        >
          إضافة ضريبة
        </Button>
      </div>

      <FormModal
        form={form}
        isEditing={isEditing}
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        loading={isAdding || isUpdating}
      />

      <DataTable
        columns={columns}
        data={taxes}
        handleEditClick={handleEditClick}
        handleDeletClick={handleDeleteClick}
        isLoading={isTaxesLoading || isDeleting}
      />
    </div>
  );
}

export default Taxes;
